import React from 'react';
import { Box, Button, Link } from '@99designs/emu';
import { FormattedReactMessage } from '@99designs/frontend-components/i18n';
import { linkTo } from '../../common/linkTo';
import { Layout } from '../Layout';

export function TermsUpdate({
    redirectUrl,
    onTermsAcceptance,
}: {
    redirectUrl: string;
    onTermsAcceptance: (target: string) => void;
}) {
    return (
        <Layout title={__('Update to our Terms of Use')} heading={__('Update to our Terms of Use')}>
            <Box>
                <p>
                    {__(
                        'We would like to inform you of a recent change we’ve made to our Terms of Use.'
                    )}
                </p>
                <p>
                    {__(
                        'You can no longer include personal contact information in your 99designs Profile such as:'
                    )}
                </p>
                <ul>
                    <li>{__('email')}</li>
                    <li>{__('video and messaging chat (e.g. Skype)')}</li>
                    <li>{__('phone')}</li>
                </ul>
                <p>{__('However, you can include:')}</p>
                <ul>
                    <li>{__('your personal website')}</li>
                    <li>{__('offsite portfolios showcasing your work')}</li>
                </ul>
                <p>
                    {__(
                        '99designs is continuing to build a platform that supports and protects designers from situations like phishing, client and payment disagreements, etc.'
                    )}
                </p>
                <p>
                    <FormattedReactMessage
                        message={__(
                            'Please take a moment to read the change under <Link>4.2 Non-Circumvention</Link>, and keep in mind that by continuing to use our services you are agreeing to our Terms. '
                        )}
                        replacements={{
                            Link: <Link href={linkTo.termsOfUse()} target="_blank" />,
                        }}
                    />
                </p>
                <Button
                    href={redirectUrl}
                    appearance="primary"
                    width="fill"
                    onClick={(e) => {
                        e.preventDefault();
                        onTermsAcceptance(redirectUrl);
                    }}
                >
                    {__('Continue')}
                </Button>
            </Box>
        </Layout>
    );
}
